import { title } from "assets/jss/material-kit-react.js";

const workStyle = {
  section: {
    padding: "70px 0"
  },
  title: {
    ...title,
    marginBottom: "50px",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "center"
  },
  container2: {
    position: "absolute",
    zIndex: "1200",
    color: "black",
    justifyContent: "flex-start",
  },
  title2: {
    ...title,
    flex: 1,
    minHeight: "32px",
    fontSize: "78px",
    color: "#FFFFFF",
    textDecoration: "none",
    textAlign: "center",
  },
  title3: {
    ...title,
    flex: 1,
    minHeight: "32px",
    fontSize: "32px",
    color: "#FFFFFF",
    marginTop: "-10px",
    textDecoration: "none",
    textAlign: "center",
  },
  logo: {
    color: "black",
    width: "50%",
    height: "50%",
  },
  description: {
    color: "#000",
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  }
};

export default workStyle;
